/** useRunReconciliation — F-009.5 (trigger manuale admin). */
import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';

import {
  runReconciliation,
  errorMessageFor,
  type ReconciliationReport,
} from '../lib/reconciliation-client';

export function useRunReconciliation() {
  return useMutation<ReconciliationReport, unknown, { lookbackHours?: number } | undefined>({
    mutationFn: (vars) => runReconciliation(vars?.lookbackHours),
    onSuccess: (report) => {
      if (report.recovered > 0) {
        toast.success(
          `Riconciliazione completata: ${report.recovered} ricariche recuperate.`,
        );
      } else {
        toast.success('Riconciliazione completata: tutto allineato.');
      }
    },
    onError: (err) => {
      toast.error(errorMessageFor(err));
    },
  });
}
